import { render, staticRenderFns } from "./employeesJob copy.vue?vue&type=template&id=0f53ef01&"
import script from "./employeesJob copy.vue?vue&type=script&lang=js&"
export * from "./employeesJob copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports